import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import Documented from 'components/help/Documented.js';
import DeletableEffectComponent from 'components/effects/DeletableEffectComponent.js';
import {getEffect} from './getEffect.js';
import {connect} from 'react-redux';
import {useScroll} from './useScroll.js';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js";


const EffectComponent = memo((props) => { 
    let effectRef = useRef(undefined);
    // useConsumeWheel(effectRef);
    let inner = (
          <DeletableEffectComponent
            {... props}
            onDeleteEffect={props.onDeleteEffect}
            effectNumber={props.effectNumber}
            onToggle={() => []}
            track={props.track}
            group={props.group}
            showDelete={props.showDelete}
            send={props.send}
            noSelect={props.noSelect}
            effect={props.effect}
            automation={props.automation}>
            {getEffect(props)}
          </DeletableEffectComponent>);
    return (
        <div ref={effectRef} className="audio-effect-container">
          <Documented element={props.effect}>
            {inner}
          </Documented>
        </div>
    );
});

const mapStateToProps = (state, props) => {
  return {
      linkedParameterSelected: state.effects.accumulatorParameterSelected,
      preset: props.effect.preset
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectComponent);
